var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-level"},[_vm._t("default"),(_vm.parent)?_c('core-dropdown-item',{attrs:{"type":"divide"}}):_vm._e(),(_vm.parent)?_c('core-dropdown-item',{attrs:{"type":"level","back":true},on:{"level":function($event){return _vm.$emit('level', _vm.parent)}}},[_vm._v("Back")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }